export const banners = [
  {
    title: "Explore Innovation",
    subtitle: "Discover cutting-edge electronics & IT solutions.",
    image: require("../Assets/Images/InnovativeProducts.png"),
  },
  {
    title: "Discover DJI",
    subtitle: "Smart. Stable. Spectacular.",
    image: require("../Assets/Images/DJI_Products.png"),
  },
  {
    title: "Unleash Gaming Power",
    subtitle: "Experience unmatched performance and next-gen graphics.",
    image: require("../Assets/Images/alian.png"),
  },
  {
    title: "Best Sellers",
    subtitle: "Excellence, chosen by many.",
    image: require("../Assets/Images/TopSeller.png"),
  },
  {
    title: "Experience VR World",
    subtitle: "It's time to see world around you.",
    image: require("../Assets/Images/VRBanner.png"),
  },
  
  {
    title: "Global Distribution",
    subtitle:
      "Expanding across North America, Europe, Middle East, India, South East Asia, Australia",
    image: require("../Assets/Images/Globaldistributions.png"),
  },
];
